const affirmations = [
    "I got this",
    "I'll figure this out",
    "I believe in myself",
    "Sucking at something is the first step towards being good at something",
    "Struggling is a part of learning",
    "Everything has cracks - that's how the light gets in",
    "Mistakes don't make me less capable",
    "We are all works in progress",
    "I am a capable human",
    "I know more than I think",
    "If everything was easy I'd be bored",
    "I am resourceful and clever",
    "I will find a way",
    "I know I will sort it out",
    "Struggling means I'm learning",
    "I am doing a great job",
    "My mind is full of brilliant ideas",
    "I make a difference in the world by simply existing in it",
    "I am learning valuable lessons from myself every day",
    "I am worthy and deserving of respect",
    "I know more than I knew yesterday",
    "My life is already a miracle of chance waiting for me to shape its destiny",
    "Nothing is impossible. The word itself says 'I’m possible!'",
    "Failure is just another way to learn how to do something right",
    "I give myself permission to do what is right for me",
    "It is not a sprint, it is a marathon. One step at a time",
    "Success is the progressive realization of a worthy goal",
    "People with goals succeed because they know where they’re going",
    "All I need is the plan, the roadmap, and the courage to press on to my destination",
    "The opposite of courage in our society is not cowardice... it is conformity",
    "Whenever we’re afraid, it’s because we don’t know enough. If we understood enough, we would never be afraid",
    "The past does not equal the future",
    "The path to success is to take massive, determined action",
    "It’s what you practice in private that you will be rewarded for in public",
    "Small progress is still progress",
    "Starting is the most difficult step - but I can do it",
    "Don't forget to enjoy the journey",
    "It's not a mistake, it's a learning opportunity",
    "I create a safe and secure space for myself wherever I am.",
    "I give myself permission to do what is right for me.",
    "I give myself space to grow and learn.",
    "allow myself to be who I am without judgment.",
    "I listen to my intuition and trust my inner guide.",
    "I accept my emotions and let them serve their purpose.",
    "I give myself the care and attention that I deserve.",
    "My drive and ambition allow me to achieve my goals.",
    "I trust that I am on the right path.",
    "I am creatively inspired by the world around me.",
    "I put my energy into things that matter to me.",
    "I am becoming closer to my true self every day.",
    "I am at peace with who I am as a person."
]

export default affirmations